var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHambergerIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12.5117C3 12.0975 3.33579 11.7617 3.75 11.7617H20.25C20.6642 11.7617 21 12.0975 21 12.5117C21 12.9259 20.6642 13.2617 20.25 13.2617H3.75C3.33579 13.2617 3 12.9259 3 12.5117Z",
    fill: "#050505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.51172C3 6.09751 3.33579 5.76172 3.75 5.76172H20.25C20.6642 5.76172 21 6.09751 21 6.51172C21 6.92593 20.6642 7.26172 20.25 7.26172H3.75C3.33579 7.26172 3 6.92593 3 6.51172Z",
    fill: "#050505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18.5117C3 18.0975 3.33579 17.7617 3.75 17.7617H20.25C20.6642 17.7617 21 18.0975 21 18.5117C21 18.9259 20.6642 19.2617 20.25 19.2617H3.75C3.33579 19.2617 3 18.9259 3 18.5117Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHambergerIcon2);
export default __webpack_public_path__ + "static/media/hambergerIcon (2).569aee2c90da2290f39e3db3f944951b.svg";
export { ForwardRef as ReactComponent };